import BaseModel from '../BaseModel';

export default class Skill extends BaseModel {
  static entity = 'skills';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null).nullable(),
      locale: this.string(null).nullable(),
    };
  }

  static apiConfig = {
    actions: {
      fetch(locale) {
        return this.get('skills', { params: { locale } }, { save: false });
      },
    },
  }
}
